/* Cart drawer: review quote from Yotpo, accessory cards (count, colour, add). */
(function () {
  // Cart prices always show the cents ($499.00, $35.40, CNV-7255). The shop format has no
  // decimals, so whole dollars go through it and the cents are appended (snippets/money-cents).
  function formatMoney(cents) {
    var frac = cents % 100;
    var out = window.theme && theme.Shopify && theme.Shopify.formatMoney && theme.money_format
      ? theme.Shopify.formatMoney(cents - frac, theme.money_format)
      : '$' + (cents - frac) / 100;
    return out + '.' + ('0' + frac).slice(-2);
  }

  function dispatchCartChanged() {
    document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
  }

  // ---------------------------------------------------------------- review card
  function pickReview(reviews) {
    var short = reviews.filter(function (r) { return r.content && r.content.trim().length <= 200; });
    return short[0] || reviews[0] || null;
  }

  function initReviews() {
    document.querySelectorAll('[data-cart-review]:not([data-loaded])').forEach(function (card) {
      card.setAttribute('data-loaded', 'true');
      var key = card.getAttribute('data-yotpo-key');
      var productId = card.getAttribute('data-yotpo-product');
      if (!key || !productId) return;
      fetch('https://api-cdn.yotpo.com/v1/widget/' + key + '/products/' + productId + '/reviews.json?per_page=5&page=1')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var reviews = data && data.response && data.response.reviews;
          var review = reviews && reviews.length ? pickReview(reviews) : null;
          if (!review || !review.content) return;
          var text = review.content.trim();
          if (text.length > 220) text = text.slice(0, 217).replace(/\s+\S*$/, '') + '…';
          var quote = card.querySelector('[data-cart-review-quote]');
          quote.textContent = '"' + text + '"';
          quote.hidden = false;
          card.hidden = false;
          var name = (review.user && review.user.display_name) || '';
          if (!name) return;
          card.querySelector('[data-cart-review-name]').textContent = name;
          card.querySelector('[data-cart-review-initials]').textContent = name
            .split(/\s+/).map(function (w) { return w.charAt(0); }).join('').slice(0, 2).toUpperCase();
          card.querySelector('[data-cart-review-verified]').hidden = !review.verified_buyer;
          card.querySelector('[data-cart-review-author]').hidden = false;
        })
        .catch(function () {});
    });
  }

  // ---------------------------------------------------------------- accessory cards
  function cardVariants(card) {
    var json = card.querySelector('[data-cart-addon-variants]');
    try { return JSON.parse(json ? json.textContent : '[]'); } catch (err) { return []; }
  }

  // Same rounding as snippets/bfcm-price: the discount is rounded to the cent, then taken off.
  function salePrice(card, price) {
    var off = 100 - (parseInt(card.getAttribute('data-keep'), 10) || 100);
    return price - Math.round(price * off / 100);
  }

  // The card's variant for the chosen count/colour: count switches the variant only for
  // products with a Single/Dual option, otherwise Dual means quantity two.
  function findVariant(card, count, colour) {
    var byCount = card.getAttribute('data-count-mode') === 'variant';
    var match = cardVariants(card).filter(function (v) {
      return (!byCount || v.count === count) && (!colour || v.colour === colour);
    });
    return match.filter(function (v) { return v.available; })[0] || match[0] || null;
  }

  function applyVariant(card) {
    var count = card.getAttribute('data-count');
    var colour = card.getAttribute('data-colour');
    var variant = findVariant(card, count, colour);
    if (!variant) return;
    var byCount = card.getAttribute('data-count-mode') === 'variant';
    card.setAttribute('data-variant-id', variant.id);
    // Dual on a quantity product (snack tray, basket) adds two: the card price follows (site notes 10.27).
    var qty = !byCount && count === 'Dual' ? 2 : 1;
    card.setAttribute('data-quantity', qty);
    var amount = card.querySelector('[data-cart-addon-amount]');
    var was = card.querySelector('[data-cart-addon-was]');
    var sale = salePrice(card, variant.price);
    // Was price: the price before the code sale, or the compare-at when the variant is priced for the sale.
    var wasPrice = sale < variant.price ? variant.price : (variant.compare > variant.price ? variant.compare : 0);
    if (amount) amount.textContent = formatMoney(sale * qty);
    if (was) {
      was.hidden = !wasPrice;
      if (wasPrice) was.textContent = formatMoney(wasPrice * qty);
    }
    card.querySelectorAll('[data-cart-addon-chip]').forEach(function (chip) {
      var chipCount = chip.getAttribute('data-cart-addon-chip');
      var chipVariant = byCount ? findVariant(card, chipCount, colour) : variant;
      var price = chipVariant ? salePrice(card, chipVariant.price) : 0;
      chip.textContent = formatMoney(byCount || chipCount === 'Single' ? price : price * 2);
    });
  }

  document.addEventListener('click', function (event) {
    var count = event.target.closest('[data-cart-addon-count]');
    if (count) {
      var countCard = count.closest('[data-cart-addon]');
      countCard.setAttribute('data-count', count.getAttribute('data-cart-addon-count'));
      countCard.querySelectorAll('[data-cart-addon-count]').forEach(function (b) { b.classList.toggle('is-selected', b === count); });
      applyVariant(countCard);
      return;
    }

    var colour = event.target.closest('[data-cart-addon-color]');
    if (colour) {
      var colourCard = colour.closest('[data-cart-addon]');
      colourCard.setAttribute('data-colour', colour.getAttribute('data-cart-addon-color'));
      colourCard.querySelectorAll('[data-cart-addon-color]').forEach(function (b) { b.classList.toggle('is-selected', b === colour); });
      applyVariant(colourCard);
      return;
    }

    var add = event.target.closest('[data-cart-addon-add]');
    if (!add) return;
    var card = add.closest('[data-cart-addon]');
    var variantId = parseInt(card.getAttribute('data-variant-id'), 10);
    var quantity = parseInt(card.getAttribute('data-quantity'), 10) || 1;
    if (!variantId) return;
    add.classList.add('is-loading');
    add.disabled = true;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        add.classList.remove('is-loading');
        add.classList.add('is-added');
        add.textContent = add.getAttribute('data-added-label') || add.textContent;
        // The drawer re-renders itself; the added product leaves the carousel.
        dispatchCartChanged();
      })
      .catch(function () {
        add.classList.remove('is-loading');
        add.disabled = false;
      });
  });

  // ---------------------------------------------------------------- init
  var timer = null;
  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(initReviews, 60);
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    initReviews();
    var drawer = document.querySelector('.cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    }
  });
})();
